import axios, { Canceler } from 'axios'

import { EnhancedWithAuthHttpService } from './http-auth.service'
import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'

import { IUsersSessionsRespDto } from 'src/types'

class UserSessionsService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler

  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getUsersSessions(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }

    return this.get<IUsersSessionsRespDto>('user-sessions', {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }
}

export const userSessionsService = new UserSessionsService()
export default UserSessionsService
